query ListMyConnections {
  connections: StreamToolsListMyConnections {
    provider
    status
    twitchUserId
    youtubeChannelId
    login
    displayName
    avatarUrl
    scopes
    connectedAt
    botModStatus
  }
}
